module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-page"
  }, [_c('HeaderTpl', {
    attrs: {
      "title": '开讲',
      "backTrack": 'djk-kj-home_back'
    }
  }), _vm._v(" "), (_vm.catagoryList && _vm.catagoryList.length > 0) ? [_c('div', {
    staticClass: "nav-wap"
  }, [_c('ul', {
    staticClass: "nav-list",
    attrs: {
      "data-track": "djk-kj-home_category_click"
    }
  }, _vm._l((_vm.catagoryList), function(item, index) {
    return _c('li', {
      staticClass: "nav-item",
      class: {
        'cur': (!_vm.currentCatagoryId && index === 0) || item.id == _vm.currentCatagoryId
      },
      on: {
        "click": function($event) {
          _vm.switchTab(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.name) + "\n        ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "navdown",
    attrs: {
      "data-track": "djk-kj-home_category_unfold"
    },
    on: {
      "click": function($event) {
        _vm.showNavBox = true
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.showNavBox) ? [_c('div', {
    staticClass: "nav-box"
  }, [_c('div', {
    staticClass: "nav-box-head"
  }, [_c('p', [_vm._v("\n          全部分类\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "navhide",
    attrs: {
      "data-track": "djk-kj-home_category_fold"
    },
    on: {
      "click": function($event) {
        _vm.showNavBox = false
      }
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "nav-box-list",
    attrs: {
      "data-track": "djk-kj-home_category_click"
    }
  }, _vm._l((_vm.catagoryList), function(item, index) {
    return _c('li', [_c('a', {
      class: item.id == _vm.currentCatagoryId ? 'on' : '',
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.switchTab(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "mask",
    on: {
      "touchend": function($event) {
        _vm.showNavBox = false
      }
    }
  })] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "course-wap"
  }, [(_vm.error) ? _c('div', {
    staticClass: "netError"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/home/netError@2x.png"),
      "alt": "网络出错"
    }
  }), _vm._v(" "), _c('p', [_vm._v("网络出错")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:location.reload();"
    }
  }, [_vm._v("刷新重试")])]) : [(!_vm.courseList || _vm.courseList.length <= 0) ? _c('div', {
    staticClass: "empty_wrap"
  }, [_vm._m(0)]) : _vm._l((_vm.courseList), function(item) {
    return [(item) ? _c('div', {
      staticClass: "course"
    }, [
      [_c('div', {
        staticClass: "tit"
      }, [_vm._v("\n            " + _vm._s(item.statsDesc) + "\n            "), (item.startStatus == 2) ? _c('i', [_vm._v(" | 可以继续畅听")]) : _vm._e()]), _vm._v(" "), _c('ul', {
        staticClass: "course-list"
      }, _vm._l((item.list), function(classitem) {
        return _c('li', {
          attrs: {
            "data-id": classitem.id
          },
          on: {
            "click": function($event) {
              _vm.goToClass(classitem)
            }
          }
        }, [_c('div', {
          staticClass: "video-box"
        }, [_c('img', {
          attrs: {
            "src": classitem.picture
          }
        }), _vm._v(" "), (item.startStatus == 1) ? _c('p', {
          staticClass: "video-status processing"
        }, [_c('i'), _c('span', [_vm._v("进行中")])]) : (item.startStatus == 0) ? _c('p', {
          staticClass: "video-status start"
        }, [(classitem.time) ? [_c('span', [_vm._v(_vm._s(classitem.time))])] : [(classitem.countTime) ? _c('i') : _vm._e(), _c('span', [_vm._v(_vm._s(classitem.countTime ? classitem.countTime : ''))])]], 2) : (item.startStatus == 2) ? _c('p', {
          staticClass: "video-status"
        }, [_c('span', {
          staticClass: "go-on"
        }, [_vm._v("继续畅听")])]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "info"
        }, [_c('p', {
          staticClass: "tit-info"
        }, [(classitem.type === 2) ? _c('span', {
          staticClass: "serial-icon"
        }) : _vm._e(), _vm._v(_vm._s(classitem.name))]), _vm._v(" "), _c('p', {
          staticClass: "expert"
        }, [_vm._v("\n                  " + _vm._s(classitem.expertName) + "  " + _vm._s(classitem.expertTitle) + "\n                ")]), _vm._v(" "), _c('p', {
          staticClass: "price-join"
        }, [(classitem.hasBuy) ? _c('span', {
          staticClass: "hasbug-icon"
        }) : _vm._e(), _vm._v(" "), (!classitem.hasBuy) ? _c('span', {
          staticClass: "price"
        }, [_vm._v("￥" + _vm._s(classitem.price))]) : _vm._e(), _vm._v(" "), (!classitem.hasBuy) ? _c('del', {
          staticClass: "old-price"
        }, [_vm._v("￥" + _vm._s(classitem.lastPrice))]) : _vm._e(), _vm._v(" "), _c('ScoreLabel', {
          attrs: {
            "data": classitem.pointDTO,
            "type": "list"
          }
        }), _vm._v(" "), (classitem.joinNum >= 10) ? _c('span', {
          staticClass: "join-cont"
        }, [_vm._v(_vm._s(classitem.joinNum) + "人参加")]) : _vm._e()], 1)])])
      }))]
    ], 2) : _vm._e()]
  }), _vm._v(" "), (_vm.courseList && _vm.courseList.length > 0) ? _c('div', {
    staticClass: "show-none"
  }, [_vm._v("\n        ── " + _vm._s(_vm.isBottom ? '已经到底啦' : '加载中') + " ──\n      ")]) : _vm._e()]], 2), _vm._v(" "), _c('loading', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('GoTop'), _vm._v(" "), _c('AdTip')], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/home/empty@2x.png"),
      "alt": "暂时没有课程"
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无课程~")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39167b1f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/user/page/Home.page.vue
// module id = 1081
// module chunks = 85